const _throttle = require('lodash.throttle');

class Field {
    constructor() {
        this.initialRender = true;
        this.field = document.getElementById('field');
        this.fieldHeight = undefined;
        this.fieldWidth = undefined;
        this.fieldTop = undefined;
        this.fieldLeft = undefined;

        this.fieldRects = undefined;

        this.mousePosition = {
            x: 0,
            y: 0
        };

        this.numRows = 35;
        this.numCols = 20;

        this.rectHeight = 1;
        this.rectWidth = 30;

        this.paddingLeft = 450;
        this.paddingTop = 350;

        this.zoom = 1.05;

        this.initial();
    }
    initial() {
        Math.degrees = function(radians) {
            return radians * 180 / Math.PI;
        };

        setTimeout(() => {
            this.setCanvasDimensions();
            this.addEventListeners();
            this.handleRectangles();
        }, 500);
    }
    addEventListeners() {
        
        this.field.addEventListener('mousemove', _throttle(event => {
            this.mousePosition = {
                x: event.x,
                y: event.y + window.pageYOffset
            };

            this.handleRectangles();
        }, 40));
        
        this.field.addEventListener('touchmove', _throttle(event => {
            this.mousePosition = {
                x: event.x,
                y: event.y + window.pageYOffset
            };

            this.handleRectangles();
        }, 20));

        window.addEventListener('resize', () => {
            this.setCanvasDimensions();
            this.handleRectangles();
        });

        this.field.addEventListener('mousedown', event => {
            this.zoom = 1.15;
        });
        this.field.addEventListener('mouseup', event => {
            this.zoom = 1.05;
        });
    }
    setCanvasDimensions() {
        if (window.innerWidth < 1400) {
            this.paddingTop = 250;
            this.paddingLeft = 300;
            this.numRows = 35;
            this.numCols = 25;
        }
        if (window.innerWidth < 1100) {
            this.paddingTop = 350;
            this.paddingLeft = 250;
            this.numRows = 35;
            this.numCols = 20;
        }
        if (window.innerWidth < 950) {
            this.paddingTop = 150;
            this.paddingLeft = 400;
            this.numRows = 35;
            this.numCols = 20;
        }
        if (window.innerWidth < 900) {
            this.paddingTop = 150;
            this.paddingLeft = 250;
            this.numRows = 35;
            this.numCols = 20;
        }
        if (window.innerWidth < 650) {
            this.paddingTop = 150;
            this.paddingLeft = 150;
            // this.numRows = 45;
            // this.numCols = 10;
            this.numRows = 35;
            this.numCols = 20;
        }

        this.fieldHeight = window.innerHeight / 1.2;
        this.fieldWidth = window.innerWidth / 1;

        this.field.setAttribute('height', `${this.fieldHeight}`);
        this.field.setAttribute('width', `${this.fieldWidth}`);

        this.fieldLeft = this.field.clientLeft;
        this.fieldTop = this.field.clientTop;

        this.distX = (this.fieldWidth - this.paddingLeft) / this.numCols;
        this.distY = (this.fieldHeight - this.paddingTop) / this.numRows;

        this.paddingX = this.distX / 2 - this.rectWidth / 2 + this.paddingLeft / 2;
        this.paddingY = this.distY / 2 - this.rectHeight / 2 + this.paddingTop / 2;

        this.rectWidth = window.innerWidth / this.numCols / 1.8;
    }

    handleRectangles() {
        const svgns = 'http://www.w3.org/2000/svg';
        for (let i = 0; i < this.numRows; i += 1) {
            for (let j = 0; j < this.numCols; j += 1) {
                
                const posX = this.distX * j + this.paddingX;
                const posY = this.distY * i + this.paddingY;
                if (this.initialRender) {

                    const rect = document.createElementNS(svgns, 'rect');
                    rect.setAttributeNS(null, 'id', `rect-${i}-${j}`);
                    rect.setAttributeNS(null, 'x', posX);
                    rect.setAttributeNS(null, 'y', posY);
                    rect.setAttributeNS(null, 'height', `${this.rectHeight}`);
                    rect.setAttributeNS(null, 'width', `${this.rectWidth}`);
                    rect.setAttributeNS(null, 'fill', 'rgb(249,0,0)');
                    // rect.setAttribute('transform', 'translate3d(0,0,0)');

                    this.field.appendChild(rect);
                } else {
                    const item = document.getElementById(`rect-${i}-${j}`);
                    item.setAttributeNS(null, 'x', posX);
                    item.setAttributeNS(null, 'y', posY);
                    item.setAttributeNS(null, 'height', `${this.rectHeight}`);
                    item.setAttributeNS(null, 'width', `${this.rectWidth}`);

                    const rotationValue = this.getRectRotation(posX, posY);
                    item.setAttribute('transform', `rotate(${rotationValue}, ${this.zoom * posX}, ${posY})`);
                }
            }
        }

        this.initialRender = false;
    }

    getRectRotation(xPosition, yPosition) {
        if (!this.mousePosition) {
            return;
        }
        const radian = Math.atan2(this.mousePosition.y - yPosition, this.mousePosition.x - xPosition);
        return Math.degrees(radian);
    }
}

export default Field;



// WEBPACK FOOTER //
// ./src/modules/snippets/Field.js